<h3>{{ getTitle(booking_offer) }}</h3>
<div [innerHTML]="getTranslated(booking_offer,'description')"></div>
<div class="grid">
  <div class="grid__cell grid__cell--widget widget__bag" [dragula]='"widget-bag"'>
    <div class="widget__wrap">
      <div class="widget" id="booking-offers-widget">
        <h2 class="widget__header">
          <span class="widget__header__title">
            <i class="widget__header__icon ico-angle-down"></i> Přehled rezervací</span>
          <span class="widget__header__tools">
            <a [routerLink]="['/bookings/holidays/add/' + id]" class="cta cta--small cta--green">
              <span class="cta__light">Přidat</span> prázdniny
              <i class="ico-plus"></i>
            </a>
          </span>
        </h2>
        <div class="widget__content">
          <button class="cta cta--small" (click)="prev()"><i class="ico-angle-left"></i></button>
          {{ date | date:'MM y' }}
          <button class="cta cta--small" (click)="next()"><i class="ico-angle-right"></i></button>
          <div class="bookings">
            <div class="bookings__day-header" *ngFor="let dayHeader of dayHeaders">{{ dayHeader }}</div>
            <ng-container *ngIf="booking_offer && days">
              <div *ngFor="let preDay of preDays" class="bookings__day--filler"></div>
              <button *ngFor="let day of days" class="bookings__day"
                [ngClass]="{'bookings__day--booked': isBooked(day), 'bookings__day--disabled': isDisabled(day), 'bookings__day--cancelled': isCancelled(day) }"
                [routerLink]="{ outlets: { modal: [day.format('Y-MM-DD')] } }">
                {{ day.format('DD') }}
              </button>
              <div *ngFor="let postDay of postDays" class="bookings__day--filler"></div>
            </ng-container>
            <div *ngIf="loading">Loading...</div>
          </div>
        </div>
      </div>
    </div>
  </div>
